<section class="l-staticModal">
  <div class="staticModal">
    <app-nodata img="/assets/images/tickets/reserve-faild.png" title="فشلت عمليه الحجز    ">
    </app-nodata>
  </div>
</section>
<section class="l-staticModal">
  <div class="staticModal">
    <app-nodata img="/assets/images/not-found/ticketSuccess.png" title="تم شراء تذكرتك بنجاح">
    </app-nodata>
  </div>
</section>
<section class="l-staticModal">
  <div class="staticModal">
    <app-nodata>
    </app-nodata>
  </div>
</section>
